import PropTypes from 'prop-types';
import { Component } from 'react';
import Flux from '../../../flux/Flux';

function withGuestGuard(WrappedComponent, { guardFn }) {
	class withGuestGuard extends Component {
		constructor(props) {
			super(props);

			this.state = {
				isValid: guardFn(),
			};

			this.onGuestChange = this.onGuestChange.bind(this);
		}

		componentDidMount() {
			Flux.Guest.addEventListener(Flux.Guest.EVENTS.guest, this.onGuestChange);
		}

		componentWillUnmount() {
			Flux.Guest.removeEventListener(Flux.Guest.EVENTS.guest, this.onGuestChange);
		}

		onGuestChange() {
			this.setState({
				isValid: guardFn(),
			});
		}

		render() {
			return this.state.isValid ? <WrappedComponent {...this.props} /> : null;
		}
	}

	return withGuestGuard;
}

withGuestGuard.propTypes = {
	guardFn: PropTypes.func.isRequired,
};

export default withGuestGuard;
